import { Outlet } from 'react-router-dom';

const Free = () => {
  return <Outlet />;
};

export default Free;
